import React, { useState } from "react";
import MyNavbar from "./navbar";
import Footer from "./footer";
import Scrolltotopbtn from "./Scrolltotopbutton";

export default function Termsofuse() {
  const [selectedLanguage, setSelectedLanguage] = useState("English"); // Default language is English

  const handleButtonClick = (language) => {
    setSelectedLanguage(language);
    // You can handle language switching logic here
  };

  const buttonStyle = {
    padding: "10px 20px",
    fontSize: "16px",
    cursor: "pointer",
    border: "2px solid #007bff",
    backgroundColor: "#fff",
    color: "#007bff",
    borderRadius: "5px",
    transition: "all 0.3s ease",
  };

  const activeButtonStyle = {
    backgroundColor: "#007bff",
    color: "white",
    fontWeight: "bold",
  };

  const buttonGroupStyle = {
    display: "flex",
    justifyContent: "center",
    gap: "10px",
    marginTop: "20px",
  };

  const Terms = {
    English: [
    {
      heading: "Introduction",
      description: [
        "Welcome to TheResaleBazaar. These Terms of Use constitute a legally binding agreement between you (the user), and Resale Bazaar. By accessing, browsing, or using our website, you acknowledge that you have read, understood, and agree to be bound by these Terms. If you do not agree to these Terms, please refrain from using the Site.",
        "Resale Bazaar is an online platform that facilitates the purchase and sale of second-hand clothing. These Terms govern your access to and use of the Site, including any services, features, content, and transactions made through the Site.",
      ],
    },
    {
      heading: "Eligibility",
      description: [
        "The Site is intended solely for users who are at least 18 years old. By accessing or using Resale Bazaar, you represent and warrant that you are of legal age to form a binding contract and meet all the eligibility requirements. If you do not meet these requirements, you must not use the Site.",
      ],
    },
    {
      heading: "Account Registration and Responsibilities",
      description: [
        {
          subheading: "Account Creation",
          content:
            "To make purchases or sell items through Resale Bazaar, you must create an account. When registering, you agree to provide accurate, current, and complete information.",
        },
        {
          subheading: "Account Security",
          content:
            "You are responsible for safeguarding the confidentiality of your login information and for any activity that occurs under your account. You must notify us immediately of any unauthorized use of your account or any other breach of security.",
        },
        {
          subheading: "Account Termination",
          content:
            "We reserve the right to suspend or terminate your account at any time if you violate these Terms, engage in fraudulent activities, or misuse the Site in any way.",
        },
      ],
    },
    {
      heading: "Product Listings and Descriptions",
      description: [
        {
          subheading: "Accuracy of Listings",
          content:
            "While we strive to ensure that product listings are as accurate as possible, Resale Bazaar makes no representations regarding the completeness, accuracy, reliability, or timeliness of any product descriptions or images. All items sold on the Site are second-hand and may show signs of previous use.",
        },
        {
          subheading: "Condition of Products",
          content:
            "Buyers acknowledge that they are purchasing used clothing and that the condition of items will vary. We do our best to provide detailed descriptions, but minor imperfections may not always be noted.",
        },
      ],
    },
    {
      heading: "Pricing and Payments",
      description: [
        {
          subheading: "Pricing",
          content:
            "All prices listed on the Site are in dollars and are subject to change at any time without notice. We reserve the right to correct any pricing errors or inaccuracies.",
        },
        {
          subheading: "Payment Methods",
          content:
            "We accept payments through authorized payment processors, including credit cards, PayPal, and other methods indicated on the Site. By providing your payment information, you authorize us to charge the applicable fees.",
        },
        {
          subheading: "Taxes and Fees",
          content:
            "Any applicable taxes, duties, or shipping fees will be calculated and displayed at checkout. You are responsible for paying all such amounts in connection with your order.",
        },
      ],
    },
    {
      heading: "Shipping, Delivery, and Risk of Loss",
      description: [
        {
          subheading: "Shipping Policy",
          content:
            "We ship items only to addresses within the designated shipping regions listed on our Site. Shipping charges and delivery times will be provided at checkout.",
        },
        {
          subheading: "Risk of Loss",
          content:
            "Title and risk of loss for items purchased pass to the buyer upon delivery to the carrier. We are not responsible for delays or damages caused by shipping carriers.",
        },
        {
          subheading: "Tracking Information",
          content:
            "Once your item has been shipped, we will provide you with tracking information so you can monitor the progress of your order.",
        },
      ],
    },
    {
      heading: "Returns, Refunds, and Cancellations",
      description: [
        {
          subheading: "Return Policy",
          content:
            "We accept returns within 7 days of receipt if the item is not as described or is defective. To initiate a return, please contact our customer service team at theresalebazaar@gmail.com . The item must be in the same condition in which it was received, along with any original packaging and documentation.",
        },
        {
          subheading: "Refund Process",
          content:
            "Refunds will be processed within 5 days after receiving and inspecting the returned item. The original payment method will be credited.",
        },
        {
          subheading: "Return Shipping Costs",
          content:
            "Return shipping costs are the responsibility of the buyer unless the item was misrepresented on the Site or arrives damaged.",
        },
        {
          subheading: "Cancellations",
          content:
            "Once an order has been placed, it cannot be canceled unless the item has not yet been shipped. Please contact customer service to inquire about cancellations.",
        },
      ],
    },
    {
      heading: "User Conduct",
      description: [
        "You agree not to use the Site for any unlawful purpose or in any manner that could damage, disable, or impair the Site. Prohibited conduct includes, but is not limited to, engaging in fraud, harassment, or posting offensive, misleading, or false information. Resale Bazaar reserves the right to investigate and take appropriate legal action against any user who violates these Terms.",
      ],
    },
    {
      heading: "Intellectual Property",
      description: [
        {
          subheading: "Ownership of Content",
          content:
            "All content on the Site, including text, images, graphics, logos, and software, is the property of Resale Bazaar or our licensors and is protected by copyright, trademark, and other intellectual property laws. Unauthorized use of this content is strictly prohibited.",
        },
        {
          subheading: "Limited License",
          content:
            "We grant you a limited, non-exclusive, non-transferable, and revocable license to use the Site for personal and non-commercial purposes in accordance with these Terms.",
        },
      ],
    },
    {
      heading: "Limitation of Liability",
      description: [
        "To the maximum extent permitted by law, Resale Bazaar shall not be liable for any indirect, incidental, consequential, or punitive damages arising out of your use or inability to use the Site or its content. This includes, but is not limited to, damages for lost profits, lost data, or business interruption.",
      ],
    },
    {
      heading: "Governing Law and Dispute Resolution",
      description: [
        "These Terms are governed by and construed in accordance with the laws of United States, without regard to its conflict of law provisions. Any disputes arising out of or related to these Terms shall be resolved exclusively in the courts of United States.",
      ],
    },
    {
      heading: "Amendments to the Terms",
      description: [
        "We may modify or update these Terms at any time. Any changes will be effective upon posting on the Site, and your continued use of the Site after such changes constitutes your acceptance of the updated Terms. We encourage you to review these Terms periodically.",
      ],
    },
    ],
    Telugu: [
      {
        heading: "పరిచయం",
        description: [
          "TheResaleBazaar కు స్వాగతం. ఈ నిబంధనలు మీ (వినియోగదారు) మరియు Resale Bazaar మధ్య చట్టపరమైన ఒప్పందాన్ని రూపొందిస్తాయి. మా వెబ్‌సైట్‌ను యాక్సెస్ చేయడం, బ్రౌజ్ చేయడం లేదా ఉపయోగించడం ద్వారా, మీరు ఈ నిబంధనలను చదివి, అర్థం చేసుకుని, వాటిని అనుసరించేందుకు అంగీకరిస్తారని అర్ధం. మీరు ఈ నిబంధనలను అంగీకరించని పక్షంలో, దయచేసి మా వెబ్‌సైట్‌ను ఉపయోగించకుండా ఉండండి."
        ],
      },
      {
        heading: "అర్హత (Eligibility)",
        description: [
          "ఈ సైట్‌ను ఉపయోగించడానికి మీరు కనీసం 18 సంవత్సరాలు నిండిన వారై ఉండాలి. మీరు Resale Bazaar ను ఉపయోగించడమే ద్వారా, మీరు చట్టబద్ధమైన ఒప్పందాన్ని కుదుర్చుకోగల మీ అర్హతను నిర్ధారిస్తున్నట్లే. మీరు ఈ అర్హతను కలిగి లేకపోతే, సైట్‌ను ఉపయోగించరాదు.",
        ],
      },
      {
        heading: "ఖాతా నమోదు మరియు బాధ్యతలు (Account Registration and Responsibilities)",
        description: [
          "ఖాతా సృష్టి, ఖాతా భద్రత, ఖాతా రద్దు వంటి విషయాలు ఇందులో ఉన్నాయి.",
        ],
      },
      {
        heading: "ఉత్పత్తి జాబితాలు మరియు వివరణలు (Product Listings and Descriptions)",
        description: [
          "జాబితాల ఖచ్చితత్వం, ఉత్పత్తుల స్థితి మొదలైనవి ఇందులో వివరించబడ్డాయి.",
        ],
      },
      {
        heading: "ధరలు మరియు చెల్లింపులు (Pricing and Payments)",
        description: [
          "ధరలు, చెల్లింపు పద్ధతులు, పన్నులు మొదలైనవి ఇందులో ఉన్నాయి."
        ]
      },
      {
        heading:"షిప్పింగ్, డెలివరీ మరియు నష్టపు బాధ్యత (Shipping, Delivery, and Risk of Loss)",
        description:[
            "షిప్పింగ్ విధానం, నష్టపు బాధ్యత, ట్రాకింగ్ సమాచారం మొదలైనవి ఇందులో ఉన్నాయి."
        ]
      },
      {
        heading:"వాపసు, రీఫండ్ మరియు ఆర్డర్ రద్దు (Returns, Refunds, and Cancellations)",
        description:[
          "వాపసు విధానం, రీఫండ్ ప్రక్రియ, ఆర్డర్ రద్దు వంటి విషయాలు ఇందులో ఉన్నాయి."
        ]
      },
      {
        heading:"వినియోగదారు ప్రవర్తన (User Conduct)",
        description:[
          "సైట్‌ను దుర్వినియోగం చేయరాదు అనే నిబంధనలు ఇందులో ఉన్నాయి."
        ]
      },
      {
        heading:"బౌద్ధిక స్వామ్యత (Intellectual Property)",
        description:[
          "కంటెంట్ యాజమాన్యం, పరిమిత అనుమతి మొదలైనవి ఇందులో ఉన్నాయి."
        ]
      },
      {
        heading:"బాధ్యత పరిమితి (Limitation of Liability)",
        description:[
          "మేము ఎటువంటి నష్టాలకు బాధ్యత వహించము."
        ]
      },
      {
        heading:"చట్టపరమైన నిబంధనలు మరియు వివాద పరిష్కారం (Governing Law and Dispute Resolution)",
        description:[
          "ఈ నిబంధనలు అమెరికా చట్టాల ప్రకారం నిర్వహించబడతాయి."
        ]
      },
      {
        heading:"నిబంధనల మార్పులు (Amendments to the Terms)",
        description:[
          "మేము ఎప్పుడైనా ఈ నిబంధనలను మార్చగలము."
        ]
      }
    ],
    Hindi:[
        {
          heading: "परिचय",
          description: [
            "TheResaleBazaar में आपका स्वागत है। ये उपयोग की शर्तें आपके (उपयोगकर्ता) और Resale Bazaar के बीच एक कानूनी रूप से बाध्यकारी समझौता हैं। हमारी वेबसाइट तक पहुँच कर, उसे ब्राउज़ करके या उपयोग करके, आप स्वीकार करते हैं कि आपने इन शर्तों को पढ़ा, समझा और इनका पालन करने के लिए सहमत हैं। यदि आप इन शर्तों से सहमत नहीं हैं, तो कृपया साइट का उपयोग न करें।",
            "Resale Bazaar एक ऑनलाइन प्लेटफ़ॉर्म है जो सेकंड-हैंड कपड़ों की खरीद और बिक्री की सुविधा प्रदान करता है। ये शर्तें आपकी साइट तक पहुँच और उपयोग, साथ ही साइट के माध्यम से किए गए किसी भी लेनदेन, सेवाओं, विशेषताओं और सामग्री पर लागू होती हैं।",
          ],
        },
        {
          heading: "पात्रता (Eligibility)",
          description: [
            "यह साइट केवल उन्हीं उपयोगकर्ताओं के लिए है जो कम से कम 18 वर्ष के हैं। Resale Bazaar तक पहुँच कर या इसका उपयोग करके, आप पुष्टि करते हैं कि आप कानूनी रूप से एक बाध्यकारी अनुबंध करने की आयु के हैं और सभी पात्रता आवश्यकताओं को पूरा करते हैं। यदि आप इन आवश्यकताओं को पूरा नहीं करते हैं, तो आपको साइट का उपयोग नहीं करना चाहिए।",
          ],
        },
        {
          heading: "खाता पंजीकरण और जिम्मेदारियां (Account Registration and Responsibilities)",
          description: [
            {
              subheading: "खाता निर्माण",
              content:
                "Resale Bazaar के माध्यम से खरीदारी करने या वस्तुएँ बेचने के लिए, आपको एक खाता बनाना होगा। पंजीकरण करते समय, आपको सटीक, वर्तमान और पूर्ण जानकारी प्रदान करनी होगी।",
            },
            {
              subheading: "खाता सुरक्षा",
              content:
                "आप अपने लॉगिन विवरण की गोपनीयता बनाए रखने और अपने खाते के तहत किसी भी गतिविधि के लिए पूरी तरह जिम्मेदार हैं। किसी भी अनधिकृत उपयोग या सुरक्षा उल्लंघन की स्थिति में, आपको हमें तुरंत सूचित करना होगा।",
            },
            {
              subheading: "खाता समाप्ति",
              content:
                "यदि आप इन शर्तों का उल्लंघन करते हैं, धोखाधड़ी में संलग्न होते हैं, या साइट का दुरुपयोग करते हैं, तो हम किसी भी समय आपके खाते को निलंबित या समाप्त करने का अधिकार सुरक्षित रखते हैं।",
            },
          ],
        },
        {
          heading: "उत्पाद सूची और विवरण (Product Listings and Descriptions)",
          description: [
            {
              subheading: "लिस्टिंग की सटीकता",
              content:
                "हम उत्पाद लिस्टिंग को यथासंभव सटीक बनाए रखने का प्रयास करते हैं, लेकिन Resale Bazaar किसी भी उत्पाद विवरण या छवियों की पूर्णता, सटीकता, विश्वसनीयता या समयबद्धता के संबंध में कोई गारंटी नहीं देता। साइट पर बेची जाने वाली सभी वस्तुएँ सेकंड-हैंड होती हैं और इनमें पिछले उपयोग के संकेत हो सकते हैं।",
            },
            {
              subheading: "उत्पादों की स्थिति",
              content:
                "खरीदार इस बात को स्वीकार करते हैं कि वे उपयोग किए गए कपड़े खरीद रहे हैं और वस्तुओं की स्थिति अलग-अलग हो सकती है। हम विस्तृत विवरण प्रदान करने का प्रयास करते हैं, लेकिन छोटी-मोटी खामियों का उल्लेख हमेशा नहीं किया जा सकता।",
            },
          ],
        },
        {
          heading: "मूल्य निर्धारण और भुगतान (Pricing and Payments)",
          description: [
            {
              subheading: "मूल्य निर्धारण",
              content:
                "साइट पर सूचीबद्ध सभी कीमतें डॉलर में हैं और बिना किसी पूर्व सूचना के कभी भी बदली जा सकती हैं। हम किसी भी मूल्य निर्धारण त्रुटि या अशुद्धि को सही करने का अधिकार सुरक्षित रखते हैं।",
            },
            {
              subheading: "भुगतान विधियाँ",
              content:
                "हम अधिकृत भुगतान प्रोसेसर के माध्यम से भुगतान स्वीकार करते हैं, जिनमें क्रेडिट कार्ड, PayPal और साइट पर सूचीबद्ध अन्य विधियाँ शामिल हैं। अपना भुगतान विवरण प्रदान करके, आप हमें लागू शुल्क लेने के लिए अधिकृत करते हैं।",
            },
            {
              subheading: "कर और शुल्क",
              content:
                "कोई भी लागू कर, शुल्क, या शिपिंग शुल्क चेकआउट के समय गणना और प्रदर्शित किए जाएँगे। आपके ऑर्डर से संबंधित सभी करों और शुल्कों का भुगतान करने की जिम्मेदारी आपकी होगी।",
            },
          ],
        },
        {
          heading: "शिपिंग, डिलीवरी और हानि का जोखिम (Shipping, Delivery, and Risk of Loss)",
          description: [
            {
              subheading: "शिपिंग नीति",
              content:
                "हम केवल उन्हीं पते पर उत्पाद भेजते हैं जो हमारी साइट पर निर्दिष्ट शिपिंग क्षेत्रों में आते हैं। शिपिंग शुल्क और डिलीवरी का समय चेकआउट पर दिया जाएगा।",
            },
            {
              subheading: "नुकसान का जोखिम",
              content:
                "खरीदी गई वस्तुओं का शीर्षक और नुकसान का जोखिम खरीदार को डिलीवरी के समय शिपिंग कैरियर को सौंप दिया जाता है। हम शिपिंग कैरियर द्वारा उत्पन्न किसी भी देरी या क्षति के लिए उत्तरदायी नहीं हैं।",
            },
            {
              subheading: "ट्रैकिंग जानकारी",
              content:
                "एक बार जब आपका उत्पाद भेज दिया जाता है, तो हम आपको ट्रैकिंग जानकारी प्रदान करेंगे ताकि आप अपने ऑर्डर की प्रगति की निगरानी कर सकें।",
            },
          ],
        },
        {
          heading: "वापसी, धनवापसी और आदेश रद्दीकरण (Returns, Refunds, and Cancellations)",
          description: [
            {
              subheading: "वापसी नीति",
              content:
                "यदि कोई उत्पाद विवरण के अनुसार नहीं है या दोषपूर्ण है, तो हम प्राप्ति के 7 दिनों के भीतर रिटर्न स्वीकार करते हैं। रिटर्न शुरू करने के लिए, कृपया हमारी ग्राहक सेवा टीम से theresalebazaar@gmail.com पर संपर्क करें। उत्पाद उसी स्थिति में होना चाहिए जिसमें वह प्राप्त हुआ था, साथ ही मूल पैकेजिंग और दस्तावेज़ों के साथ।",
            },
            {
              subheading: "रिफंड प्रक्रिया",
              content:
                "रिफंड उस समय शुरू किया जाएगा जब हमें लौटाई गई वस्तु प्राप्त और निरीक्षित हो जाएगी। मूल भुगतान विधि को 5 दिनों के भीतर क्रेडिट किया जाएगा।",
            },
            {
              subheading: "वापसी शिपिंग लागत",
              content:
                "यदि आइटम साइट पर गलत तरीके से प्रस्तुत किया गया था या क्षतिग्रस्त होकर पहुँचा है, तो वापसी शिपिंग लागत हमारी होगी। अन्य सभी मामलों में, वापसी शिपिंग लागत खरीदार द्वारा वहन की जाएगी।",
            },
            {
              subheading: "रद्दीकरण",
              content:
                "एक बार ऑर्डर देने के बाद, उसे रद्द नहीं किया जा सकता जब तक कि वह भेजा न गया हो। रद्दीकरण के बारे में पूछताछ के लिए कृपया ग्राहक सेवा से संपर्क करें।",
            },
          ],
        },
        {
          heading: "उपयोगकर्ता आचरण (User Conduct)",
          description: [
            "आप इस साइट का उपयोग किसी भी अवैध उद्देश्य के लिए नहीं करेंगे या किसी भी ऐसे तरीके से नहीं करेंगे जो साइट को नुकसान पहुँचा सकता हो, अक्षम कर सकता हो या बाधित कर सकता हो। इसमें धोखाधड़ी, उत्पीड़न, या आपत्तिजनक, भ्रामक या गलत जानकारी पोस्ट करना शामिल है। Resale Bazaar को किसी भी उपयोगकर्ता के खिलाफ कार्रवाई करने का अधिकार सुरक्षित है जो इन शर्तों का उल्लंघन करता है।",
          ],
        },
        {
          heading: "बौद्धिक संपदा (Intellectual Property)",
          description: [
            {
              subheading: "सामग्री का स्वामित्व",
              content:
                "साइट पर उपलब्ध सभी सामग्री, जिनमें पाठ, चित्र, ग्राफिक्स, लोगो, और सॉफ़्टवेयर शामिल हैं, Resale Bazaar या हमारे लाइसेंसधारकों की संपत्ति हैं और कॉपीराइट, ट्रेडमार्क और अन्य बौद्धिक संपदा कानूनों द्वारा संरक्षित हैं। इस सामग्री का अनधिकृत उपयोग सख्त वर्जित है।",
            },
            {
              subheading: "सीमित लाइसेंस",
              content:
                "हम आपको साइट का व्यक्तिगत और गैर-व्यावसायिक उद्देश्यों के लिए उपयोग करने की एक सीमित, गैर-हस्तांतरणीय, और रद्द करने योग्य लाइसेंस प्रदान करते हैं।",
            },
          ],
        },
        {
          heading: "देयता सीमा (Limitation of Liability)",
          description: [
            "कानून द्वारा अनुमत अधिकतम सीमा तक, Resale Bazaar किसी भी अप्रत्यक्ष, आकस्मिक, परिणामी, या दंडात्मक क्षति के लिए उत्तरदायी नहीं होगा, जो आपकी साइट के उपयोग या उसके कंटेंट से संबंधित हो। इसमें खोए हुए लाभ, डेटा की हानि, या व्यापार में व्यवधान शामिल हो सकता है।",
          ],
        },
        {
          heading: "शासन कानून और विवाद समाधान (Governing Law and Dispute Resolution)",
          description: [
            "ये शर्तें संयुक्त राज्य अमेरिका के कानूनों द्वारा शासित होंगी और उनकी व्याख्या की जाएगी, बिना किसी कानून-संघर्ष प्रावधान पर ध्यान दिए। इन शर्तों से संबंधित कोई भी विवाद संयुक्त राज्य अमेरिका की अदालतों में विशेष रूप से हल किया जाएगा।",
          ],
        },
        {
          heading: "नियम और शर्तों में संशोधन (Amendments to the Terms)",
          description: [
            "हम इन शर्तों को किसी भी समय संशोधित या अपडेट कर सकते हैं। कोई भी परिवर्तन साइट पर पोस्ट होने के बाद प्रभावी होगा, और साइट का निरंतर उपयोग उन परिवर्तनों की स्वीकृति मानी जाएगी। हम आपको समय-समय पर इन शर्तों की समीक्षा करने के लिए प्रोत्साहित करते हैं।",
          ],
        },
        
    ]
  };
  return (
    <div className="fullscreen">
    <MyNavbar />
    <main>
      <div className="container pt-5 pb-5">
        <div style={buttonGroupStyle}>
          <button
            style={{
              ...buttonStyle,
              ...(selectedLanguage === "English" ? activeButtonStyle : {}),
            }}
            onClick={() => handleButtonClick("English")}
          >
            English
          </button>
          <button
            style={{
              ...buttonStyle,
              ...(selectedLanguage === "Telugu" ? activeButtonStyle : {}),
            }}
            onClick={() => handleButtonClick("Telugu")}
          >
            తెలుగు
          </button>
          <button
            style={{
              ...buttonStyle,
              ...(selectedLanguage === "Hindi" ? activeButtonStyle : {}),
            }}
            onClick={() => handleButtonClick("Hindi")}
          >
            हिंदी
          </button>
        </div>
        <h1 className="mt-3">
          {selectedLanguage === "English"
            ? "Terms of Use"
            : selectedLanguage === "Telugu"
            ? "విభజన నిబంధనలు (Terms of Use) - TheResaleBazaar"
            : "नियम और शर्तें (Terms of Use) - TheResaleBazaar"}
        </h1>
        <div className="pt-3">
          {Terms[selectedLanguage].map((item, index) => (
            <div key={index} style={{ lineHeight: "30px", marginTop: "40px" }}>
              <h5 className="fw-bold">{item.heading}</h5>
              {item.description.map((subItem, subindex) => (
                <div key={subindex}>
                  {typeof subItem === "string" ? (
                    <p>{subItem}</p>
                  ) : (
                    <ul>
                      <li>{subItem.subheading} : {subItem.content}</li>
                    </ul>
                  )}
                </div>
              ))}
            </div>
          ))}
        </div>
      </div>
    </main>
    <Footer />
    <Scrolltotopbtn />
  </div>
  );
}
